import { useLanguage } from '../../../contexts/LanguageContext';
import { CornerStatusRibbon } from '../../ui/CornerStatusRibbon';
import { APPROVAL_STATUS, type ApprovalStatus } from '@fdh/shared';

type EmployerStatusRibbonProps = {
  status: ApprovalStatus;
  submittedAt: string;
};

const STATUS_RIBBON_STYLES: Record<ApprovalStatus, string> = {
  [APPROVAL_STATUS.PENDING]:
    'bg-yellow-100 text-yellow-900 border-yellow-300 dark:bg-yellow-950/55 dark:text-yellow-100 dark:border-yellow-700',
  [APPROVAL_STATUS.APPROVED]:
    'bg-green-100 text-green-900 border-green-300 dark:bg-green-950/50 dark:text-green-100 dark:border-green-700',
  [APPROVAL_STATUS.REJECTED]:
    'bg-red-100 text-red-900 border-red-300 dark:bg-red-950/45 dark:text-red-100 dark:border-red-800',
  [APPROVAL_STATUS.NEEDS_UPDATE]:
    'bg-orange-100 text-orange-900 border-orange-300 dark:bg-orange-900/55 dark:text-orange-50 dark:border-orange-500',
  [APPROVAL_STATUS.CANCEL]:
    'bg-gray-100 text-gray-800 border-gray-300 dark:bg-gray-800 dark:text-gray-100 dark:border-gray-600',
};

const STATUS_LABEL_KEYS: Record<ApprovalStatus, string> = {
  [APPROVAL_STATUS.PENDING]: 'task.status.pending',
  [APPROVAL_STATUS.APPROVED]: 'task.status.approved',
  [APPROVAL_STATUS.REJECTED]: 'task.status.rejected',
  [APPROVAL_STATUS.NEEDS_UPDATE]: 'task.status.needsUpdate',
  [APPROVAL_STATUS.CANCEL]: 'task.status.cancel',
};

const NOT_SUBMITTED_RIBBON =
  'bg-gray-100 text-gray-600 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600';

export const EmployerStatusRibbon = ({ status, submittedAt }: EmployerStatusRibbonProps) => {
  const { t } = useLanguage();
  const isNotSubmitted =
    status === APPROVAL_STATUS.PENDING && (!submittedAt || String(submittedAt).trim() === '');

  const label = isNotSubmitted ? t('task.status.notSubmitted') : t(STATUS_LABEL_KEYS[status]);
  const styleClass = isNotSubmitted ? NOT_SUBMITTED_RIBBON : STATUS_RIBBON_STYLES[status];

  return <CornerStatusRibbon label={label} styleClass={styleClass} />;
};
